import { render, staticRenderFns } from "./receive_confirm_dialog.vue?vue&type=template&id=4a0e4dd7&scoped=true&"
import script from "./receive_confirm_dialog.vue?vue&type=script&lang=js&"
export * from "./receive_confirm_dialog.vue?vue&type=script&lang=js&"
import style0 from "./receive_confirm_dialog.vue?vue&type=style&index=0&id=4a0e4dd7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a0e4dd7",
  null
  
)

export default component.exports